<template>
  <transition name="fade" v-if="$root.$data.Notification !== null">
    <div
      class="sufee-alert alert with-close alert-dismissible fade show fixed-top"
      style="left: auto; width: auto; top: 13px; z-index: 100000000;"
      :class="'alert-' + $root.$data.Notification.type"
    >
      <span
        class="badge badge-pill mr-2"
        :class="'badge-' + $root.$data.Notification.type"
      >{{ $root.$data.Notification.title }}</span>
      <span v-html="$root.$data.Notification.content"></span>
      <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button> -->
    </div>
  </transition>
</template>
<script>
export default {
  name: "Notification",
  data() {
    return {
      shown: false,
      type: "success",
      class: null,
      title: null,
      content: null,
      timer: null
    };
  }
};
</script>